<template>
  <div>
  
        <v-row>
            <v-col cols="12" sm="12" class="text-center">
                      <img :src="company.logo" v-if="!IsEmpty(company.logo)" min-width="35%" max-width="55%"/>
                             <img v-else :src="$store.state.systemlogo" width="35%"/> 
                             <p class="text-h5 font-weight-bold text-light">Welcome back {{$session.get('title')}} {{$session.get('fullname')}}!</p>
               </v-col>
                <v-col cols="12" sm="12" class="text-center">
                             <v-btn x-large block tile  class="mb-2 " :color="item.color"   @click="$router.push(item.page).catch(err => {})"  v-for="(item,index) in operation_menu" :key="index + '-o'">
                                <v-icon color="#fff" left>{{item.icon }}</v-icon>
                                <span class="text-white">{{item.title }}</span>
                              </v-btn>
                </v-col>
             
        </v-row>

   </div>
 </template>
 <script>

 import {
   mapMutations
 } from 'vuex'
   export default {
     data: () => ({
      company:{name:"",logo:"",address:"",tel:"", mobile:"", email:""},
      USERID:0
     }),
     beforeCreate: function () {
       if (!this.$session.exists()) {
         this.$router.push('/')
       } 
     },
     created() {
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
        this.setLoggedIn(true) 
        this.USERID = this.$IsNum(this.$session.get('userID'))
        this.SETVARS()
        setTimeout(()=>{
           this.company = {
            name:this.GET_SYSVARS('company_name'),
            logo:this.GET_SYSVARS('company_logo'),
            address:this.GET_SYSVARS('company_address'),
            tel:this.GET_SYSVARS('company_tel'), 
            mobile:this.GET_SYSVARS('company_email'),
            email:this.GET_SYSVARS('company_mobile'),
          }
        },200)

     },
     computed:{
       operation_menu() {
     
        return this.MYMENUS()
      },
     },
     methods: {
       ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
     
     },
   }
 </script>